var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.3335C4 5.44788 4 4.50507 4.58579 3.91928C5.17157 3.3335 6.11438 3.3335 8 3.3335H10C11.8856 3.3335 12.8284 3.3335 13.4142 3.91928C14 4.50507 14 5.44788 14 7.3335V10.6668C14 12.5524 14 13.4953 13.4142 14.081C12.8284 14.6668 11.8856 14.6668 10 14.6668H8C6.11438 14.6668 5.17157 14.6668 4.58579 14.081C4 13.4953 4 12.5524 4 10.6668V7.3335Z",
    stroke: "#006FEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.6668C2.89543 12.6668 2 11.7714 2 10.6668V6.66683C2 4.15267 2 2.89559 2.78105 2.11454C3.5621 1.3335 4.81918 1.3335 7.33333 1.3335H10C11.1046 1.3335 12 2.22893 12 3.3335",
    stroke: "#006FEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.28637abd18b35504c221ecd999deb525.svg";
export { ForwardRef as ReactComponent };